import React from 'react';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const EmergencyPlanning = () => {
  return (
    <div className="w-full bg-white">
      <PageHeader 
        title="Emergency Management & Planning" 
        description="We draft new plans and evaluate, update, and integrate existing ones to ensure they reflect reality." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16">
          <div className="prose prose-slate prose-lg">
            <h2 className="text-brand-navy font-bold">Plans Built for Reality</h2>
            <p>
              Generic, copy-pasted plans fail when the pressure is real. Emergency documents must reflect your actual hazards, personnel, equipment, contractors, communication systems, and outside response resources.
            </p>
            <p>
              Boes & Boes works closely with facility leadership and stakeholders to develop actionable, site-specific procedures that employees can actually understand and execute.
            </p>

            <h3 className="text-brand-navy font-bold">Our Planning Capabilities</h3>
            <ul className="grid sm:grid-cols-2 gap-x-4 pl-0 list-none">
              {[
                'Emergency Action Plans (EAP)',
                'Emergency Response Plans (ERP)',
                'Business Continuity Plans (BCP)',
                'Emergency Operations Plans (EOP)',
                'EOC Procedures',
                'Hazard Vulnerability Analysis (HVA)',
                'THIRA support',
                'Hazard-specific annexes',
                'Standard operating procedures',
                'Emergency checklists & job aids',
                'Multi-site plan standardization',
                'External-agency coordination'
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-2 mb-2">
                  <SafeIcon icon={FiIcons.FiCheckCircle} className="text-brand-green shrink-0 mt-1" />
                  <span className="text-sm font-semibold">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <div className="bg-brand-light p-8 rounded-2xl border border-slate-200 shadow-sm sticky top-28">
              <h3 className="text-2xl font-bold text-brand-navy mb-6">The Planning Process</h3>
              <div className="space-y-6">
                {[
                  { title: 'Facility & Stakeholder Interviews', desc: 'Understanding your unique operational constraints.' },
                  { title: 'Hazard Assessment', desc: 'Identifying the specific risks that threaten your people and continuity.' },
                  { title: 'Drafting & Review', desc: 'Creating clear, compliant documentation without unnecessary fluff.' },
                  { title: 'Annual Reviews & Change Management', desc: 'Keeping plans alive as your business evolves.' }
                ].map((step, i) => (
                  <div key={i} className="flex gap-4">
                    <div className="w-8 h-8 rounded-full bg-brand-navy text-white flex items-center justify-center font-bold text-sm shrink-0">
                      {i + 1}
                    </div>
                    <div>
                      <h4 className="font-bold text-slate-900">{step.title}</h4>
                      <p className="text-sm text-slate-600">{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmergencyPlanning;